<template>
    <layout :show_footer="false">
        <template v-if="isCiaEnabled">
            <a-breadcrumb class="ml-4 mb-4">
                <a-breadcrumb-item data-cy="breadcrumb-main">
                    <a @click="$router.go(-1)">
                        {{ $t('globals.navigation.header.cia_view.alt_title') }}
                    </a>
                </a-breadcrumb-item>
                <a-breadcrumb-item data-cy="breadcrumb-main">
                    {{ $t('covers.forms.title.cover_info') }}
                </a-breadcrumb-item>
            </a-breadcrumb>
            <form-cover
                v-if="is_fetched"
                data-cy="cover-form"
                :cover_id="cover_id"
                :cover="cover_data"
                :validation="validation"
                :is_view="
                    isAnAdmin ||
                    cover_data.print_count > 0 ||
                    (cover_data.cover_status != 'active' && cover_data.cover_status != null)
                "
                @is-form-dirty="isFormDirty"
                @formSubmit="onSave"
                @update="updateCover"
                @cancel="onCancel"
                @refresh="refresh"
                :processing="processing"
                :form_mode="'edit'"
                ref="CoversForm"
            />
        </template>
    </layout>
</template>

<script>
import Layout from '@/layouts/Layout.vue';
import FormCover from '@/components/forms/Cover.vue';

export default {
    components: {
        Layout,
        FormCover,
    },
    data() {
        return {
            is_fetched: false,
            cover_data: {
                insurer_id: '',
                company_id: '',
                policy_number: '',
                product_code: '',
                policy_start_date: null,
                policy_end_date: null,
                policy_start_time: null,
                policy_end_time: null,
                policy_date_range: {
                    start_date: null,
                    end_date: null,
                },
                cover_effective_date: null,
                cover_expiry_date: null,
                cover_effective_time: null,
                cover_expiry_time: null,
                cover_date_range: {
                    start_date: null,
                    end_date: null,
                },
                certificate_type: '',
                cover_type: '',
                is_motor_trade: false,
                manual_certificate_number: '',
                policyholder_address: '',
                risk_mortgagee: '',
                cover_category: '',
                section_1_label: '',
                section_1: '',
                section_2_label: '',
                section_2: '',
                section_3_label: '',
                section_3: '',
                section_4_label: '',
                section_4: '',
                registration_number: '',
                chassis_number: '',
                vehicle_make: '',
                vehicle_model: '',
                vehicle_year: null,
                vehicle_color: '',
                engine_number: '',
                sum_insured: 0,
                hpcc: '',
                seating: '',
                is_authorized: false,
                can_authorize: false,
            },
            processing: false,
            form_dirty: false,
            validation: {
                errors: {},
                message: '',
            },
            cover_id: this.$route.params.id,
        };
    },
    mounted() {
        this.fetch();
    },
    computed: {
        isCiaEnabled() {
            return this.$store.state.user.modules.cia;
        },
        isAnAdmin() {
            return (
                this.$store.state.user.abilities.includes('manage-association') ||
                this.$store.state.user.abilities.includes('manage-admin')
            );
        },
    },
    methods: {
        isFormDirty(is_dirty) {
            this.form_dirty = is_dirty;
        },
        onSave() {
            if (this.processing) {
                return false;
            }

            this.form_dirty = false;
            this.processing = true;

            let params = {
                ...this.cover_data,
                company_id: this.cover_data.insurer_id,
                intermediary_id: this.cover_data.company_id,
                policy_name_list: this.$refs.CoversForm.policy_name_list,
                cover_date_range: null,
                policy_date_range: null,
                policy_start_date: this.cover_data.policy_date_range.start_date.format('YYYY-MM-DD'),
                policy_end_date: this.cover_data.policy_date_range.end_date.format('YYYY-MM-DD'),
                cover_effective_date: this.cover_data.cover_date_range.start_date.format('YYYY-MM-DD'),
                cover_expiry_date: this.cover_data.cover_date_range.end_date.format('YYYY-MM-DD'),
                policy_start_time: this.cover_data.policy_date_range.start_date.format('HH:mm:ss'),
                policy_end_time: this.cover_data.policy_date_range.end_date.format('HH:mm:ss'),
                cover_effective_time: this.cover_data.cover_date_range.start_date.format('HH:mm:ss'),
                cover_expiry_time: this.cover_data.cover_date_range.end_date.format('HH:mm:ss'),
            };

            this.$http
                .post('/api/covers/update/' + this.cover_id, params)
                .then((response) => {
                    if (response.data.status == 'success') {
                        this.form_dirty = false;

                        this.fetch();
                        this.$refs.CoversForm.refreshPolicyHoldersList();

                        this.$notification.success({
                            message: response.data.message,
                        });
                    } else {
                        this.$notification.error({
                            message: response.data.message,
                        });
                    }
                })
                .catch((error) => {
                    if (error.response.status == 422) {
                        this.validation = error.response.data;
                    } else if (error.response.status == 403) {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.403_mod'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVCA0136' }),
                        });
                    }
                })
                .finally(() => {
                    this.processing = false;
                });
        },
        updateCover(value) {
            this.cover_data = {
                ...this.cover_data,
                ...value,
            };
        },
        onCancel() {
            this.$router.go(-1);
        },
        fetch() {
            const id = this.$route.params.id;
            this.processing = true;

            this.$http
                .get('/api/covers/' + id)
                .then((response) => {
                    if (response.data.status == 'error') {
                        this.$router.go(-1);

                        this.$notification.error({
                            message: response.data.message,
                        });
                    } else {
                        this.cover_data = {
                            ...this.cover_data,
                            ...response.data.data,
                            id: null,
                            insurer_id: response.data.data.company_id,
                            insurer_name: response.data.data.name,
                            company_id: response.data.data.intermediary_id,
                            policy_date_range: {
                                start_date: this.$dayjs(response.data.data.policy_start_date),
                                end_date: this.$dayjs(response.data.data.policy_end_date),
                            },
                            is_motor_trade: response.data.data.is_motor_trade === 1 ? true : false,
                            cover_date_range: {
                                start_date: this.$dayjs(response.data.data.cover_effective_date),
                                end_date: this.$dayjs(response.data.data.cover_expiry_date),
                            },
                            printed_first_at:
                                response.data.data.printed_first_at == null
                                    ? 'N/A'
                                    : this.$dayjs(response.data.data.printed_first_at).format('YYYY-MM-DD HH:mm:ss'),
                            printed_last_at:
                                response.data.data.printed_last_at == null
                                    ? 'N/A'
                                    : this.$dayjs(response.data.data.printed_last_at).format('YYYY-MM-DD HH:mm:ss'),
                            printed_last_by:
                                response.data.data.printed_last_by == null ? 'N/A' : response.data.data.printed_last_by,
                            is_authorized: response.data.data.is_authorized === 1 ? true : false,
                            can_authorize: response.data.data.can_authorize === 1 ? true : false,
                            created_by: response.data.data.created_by == null ? 'N/A' : response.data.data.created_by,
                            created_at:
                                response.data.data.created_at == null
                                    ? 'N/A'
                                    : this.$dayjs(response.data.data.created_at).format('YYYY-MM-DD HH:mm:ss'),
                            last_updated_by:
                                response.data.data.last_updated_by == null ? 'N/A' : response.data.data.last_updated_by,
                            updated_at:
                                response.data.data.updated_at == null
                                    ? 'N/A'
                                    : this.$dayjs(response.data.data.updated_at).format('YYYY-MM-DD HH:mm:ss'),
                        };

                        this.is_fetched = true;
                    }
                })
                .catch((error) => {
                    if (error.response.status == 403) {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.403_mod'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVCE01' }),
                        });
                    }
                })
                .finally(() => {
                    this.processing = false;

                    if (this.cover_data.cover_effective_date !== null && this.cover_data.cover_expiry_date !== null) {
                        this.$refs.CoversForm.dateDifference({
                            start_date: this.cover_data.cover_date_range.start_date.format('YYYY-MM-DD HH:mm:ss'),
                            end_date: this.cover_data.cover_date_range.end_date.format('YYYY-MM-DD HH:mm:ss'),
                        });
                    }
                });
        },
        refresh() {
            this.fetch();
        },
    },
};
</script>
